/**
 * Help Button Component
 * A reusable button to trigger contextual help
 */

import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { HelpCircle } from "lucide-react";
import { cn } from "@/lib/utils";

interface HelpButtonProps {
  onClick: () => void;
  variant?: "default" | "outline" | "ghost";
  size?: "default" | "sm" | "lg" | "icon";
  className?: string;
  showLabel?: boolean;
}

export function HelpButton({
  onClick,
  variant = "outline",
  size = "default",
  className,
  showLabel = false,
}: HelpButtonProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant={variant}
            size={size}
            onClick={onClick}
            className={cn("gap-2", className)}
          >
            <HelpCircle className="h-4 w-4" />
            {showLabel && <span>Help</span>}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Get help with this page</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
